import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { I } from './kit';
import { useTour } from '../learn/TourContext';

const TABS = [
  { key: '/', icon: 'home', label: 'Home' },
  { key: '/sales', icon: 'sales', label: 'Sales' },
  { key: '/listings', icon: 'listings', label: 'Listings' },
  { key: '/earnings', icon: 'earnings', label: 'Earnings' },
  { key: '/more', icon: 'more', label: 'More' },
];

// Phone-frame shell with a fixed bottom tab bar. Screens render into <Outlet/>.
export default function AppShell() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const on = (k) => (k === '/' ? pathname === '/' : pathname.startsWith(k));
  // Keyed on the tour's remount counter so a simulated HQ beat re-reads its data.
  const { remountKey } = useTour() || {};

  return (
    <div className="app-frame">
      <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Outlet key={remountKey} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-around', padding: '8px 6px calc(8px + env(safe-area-inset-bottom))', borderTop: '1px solid var(--border)', background: 'var(--surface)', flex: 'none' }}>
        {TABS.map((t) => {
          const active = on(t.key);
          const Icon = I[t.icon];
          return (
            <div data-tour={`tab-${t.icon}`} key={t.key} onClick={() => nav(t.key)} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, fontSize: 11.5, fontWeight: 600, color: active ? 'var(--primary)' : 'var(--muted)', cursor: 'pointer', flex: 1 }}>
              <Icon width={22} height={22} />
              {t.label}
            </div>
          );
        })}
      </div>
    </div>
  );
}
